import { useTranslation } from 'react-i18next';
import { MapPin, Car, CheckCircle } from 'lucide-react';

export default function HowItWorks() {
    const { t } = useTranslation();

    const steps = [
        {
            icon: MapPin,
            title: t('howItWorks.step1_title') || "Enter Details",
            desc: t('howItWorks.step1_desc') || "Enter your pickup and dropoff locations to see the estimated distance."
        },
        {
            icon: Car,
            title: t('howItWorks.step2_title') || "Choose Vehicle",
            desc: t('howItWorks.step2_desc') || "Select the vehicle that best suits your needs and budget."
        },
        {
            icon: CheckCircle,
            title: t('howItWorks.step3_title') || "Confirm & Ride",
            desc: t('howItWorks.step3_desc') || "Receive immediate confirmation via email and enjoy your ride."
        }
    ];

    return (
        <section id="how-it-works" className="py-24 bg-white font-montserrat">
            <div className="container mx-auto px-4">
                <div className="text-center mb-20">
                    <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tighter mb-4 text-slate-900">{t('howItWorks.title') || "How It Works"}</h2>
                    <div className="h-1.5 w-24 bg-blue-600 mx-auto rounded-full" />
                </div>

                <div className="grid md:grid-cols-3 gap-16 max-w-6xl mx-auto">
                    {steps.map((step, idx) => (
                        <div key={idx} className="text-center group flex flex-col items-center">
                            <div className="relative mb-10">
                                <div className="w-24 h-24 bg-white rounded-[32px] shadow-[0_20px_40px_-10px_rgba(0,0,0,0.08)] flex items-center justify-center border border-slate-100 group-hover:border-blue-500 group-hover:scale-110 transition-all duration-500">
                                    <step.icon className="w-10 h-10 text-blue-600" />
                                </div>
                                <div className="absolute -top-4 -right-4 w-10 h-10 bg-slate-900 text-white rounded-2xl flex items-center justify-center font-black text-sm border-4 border-white shadow-lg">
                                    {idx + 1}
                                </div>
                            </div>
                            <h3 className="text-xl font-black uppercase tracking-tight mb-4 text-slate-900">{step.title}</h3>
                            <p className="text-slate-500 font-medium leading-relaxed max-w-[280px]">
                                {step.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
